"use client"

import { useQuery } from "@tanstack/react-query"
import {
  listAiUseCaseRolesAction,
  listAgentRolesAction,
  type AiUseCaseRoleView,
} from "@/server-actions/ai-use-case-roles"

export const aiUseCaseRolesQueryKey = ["ai-use-case-roles"] as const
export const agentRolesQueryKey = (useCase: string) => ["agent-roles", useCase] as const

/** All roles for the AI settings config page (gated by ai.view). */
export function useAiUseCaseRolesQuery(enabled = true) {
  return useQuery<AiUseCaseRoleView[]>({
    queryKey: aiUseCaseRolesQueryKey,
    enabled,
    queryFn: async () => {
      const result = await listAiUseCaseRolesAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}

/** Roles of one use case for agent-creation dialogs (any authenticated user). */
export function useAgentRolesQuery(useCase: string, enabled = true) {
  return useQuery<AiUseCaseRoleView[]>({
    queryKey: agentRolesQueryKey(useCase),
    enabled,
    queryFn: async () => {
      const result = await listAgentRolesAction({ use_case: useCase })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
